var map = {
	"./awesome-chess-knight.svg": "ab3f",
	"./background-code.svg": "e082",
	"./background-finished.svg": "ea94",
	"./background-scan.svg": "9180",
	"./background-wait.svg": "bace",
	"./city.svg": "7872",
	"./country.svg": "896c",
	"./icon-facts.svg": "1aa9",
	"./inject-panel.svg": "56ed",
	"./intro-lady.svg": "598a",
	"./stadium.svg": "20a2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "31e8";